import TagManager from 'react-gtm-module'

// Must stay in lockstep with the inline tracker gates in index.html — the SDKs
// load there, the events fire here, and a mismatch means one side runs while the
// other is silent. tests/canonical-host.test.ts asserts the two agree.
const CANONICAL_HOSTS = ['fun88mx.mx', 'www.fun88mx.mx']

export const isCanonicalHost = () =>
  typeof window !== 'undefined' &&
  CANONICAL_HOSTS.includes(window.location.hostname)

export const trackEvent = (event: string, payload?: Record<string, unknown>) => {
  if (!isCanonicalHost()) return
  TagManager.dataLayer({
    dataLayer: { event, ...payload },
  })
}

// Canonical-host-gated wrappers around the raw Facebook Pixel / Twitter
// globals. Call sites MUST use these instead of `fbq`/`twq` directly so the
// host gate lives in one place and isn't silently bypassed.
export const trackFb = (...args: Parameters<typeof fbq>) => {
  if (!isCanonicalHost()) return
  fbq(...args)
}

export const trackTwitter = (...args: Parameters<typeof twq>) => {
  if (!isCanonicalHost()) return
  twq(...args)
}
